
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { GoogleBigQueryLinkedService } from 'app/model/linkedservice/google-bigquery.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.googleBigQuery.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorLegacyNameByFlag(stringResources.GoogleBigQuery_DisplayText, true)),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorLegacyNameByFlag(stringResources.GoogleBigQuery_DisplayText, true))
    ],
    disabled: __IS_FABRIC_DPE__,
    constraints: {
        linkedService: {
            model: GoogleBigQueryLinkedService.MODEL // Linked service redefined
        }
    }
})
export class GoogleBigQueryObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
